import { useState } from 'react';
import { Modal } from './Modal.jsx';
import { Icon } from './Icon.jsx';
import { useT } from '../i18n/index.js';

const PAYPAL_USER = 'benbenIA';
const PRESETS = [1, 5, 10, 20, 50, 100];

export function DonateModal({ open, onClose }) {
  const t = useT();
  const [amount, setAmount] = useState(5);
  const [custom, setCustom] = useState('');

  const effective = custom.trim() !== '' ? Math.max(1, Math.floor(Number(custom) || 0)) : amount;
  const valid = effective >= 1;

  const donate = () => {
    if (!valid) return;
    const url = `https://www.paypal.com/paypalme/${PAYPAL_USER}/${effective}`;
    window.open(url, '_blank', 'noopener,noreferrer');
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t('donate.title')}
      footer={
        <>
          <button className="btn sm" onClick={onClose}>{t('modal.cancel')}</button>
          <span className="grow" />
          <button className="btn primary sm donate-btn" onClick={donate} disabled={!valid}>
            <Icon name="heart" size={14} /> {t('donate.confirm', { amount: effective })}
          </button>
        </>
      }
    >
      <div className="col" style={{ gap: 14 }}>
        <p className="tiny muted" style={{ margin: 0 }}>{t('donate.intro')}</p>
        <div className="donate-grid">
          {PRESETS.map((v) => (
            <button
              key={v}
              className={`donate-tile ${custom.trim() === '' && amount === v ? 'active' : ''}`}
              onClick={() => { setAmount(v); setCustom(''); }}
            >
              {v} €
            </button>
          ))}
        </div>
        <label className="col" style={{ gap: 4 }}>
          <span className="tiny muted">{t('donate.custom')}</span>
          <input
            type="number"
            min="1"
            step="1"
            className="sig-type-input"
            placeholder={t('donate.custom_placeholder')}
            value={custom}
            onChange={(e) => setCustom(e.target.value)}
          />
        </label>
      </div>
    </Modal>
  );
}
